import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import getClientMode from 'src/store/utils-store/selectors';
import useStyles from './styles';
const cards = [
  {
    section: 'Repositorios',
    cards: [
      { title: 'Repositorio General', path: '/cliente/documentos-generales' },
      { title: 'Repositorio Personal', path: '/cliente/documentos' },
    ],
    path: '',
  },
  {
    section: 'Documentos',
    cards: [
      { title: 'Ficha Colaborador', path: '/cliente/ficha-cliente' },
      { title: 'Firmas Pendientes', path: '/cliente/firmas' },
    ],
    path: '',
  },
  // {
  //   title: 'Eventos',
  //   cards: ['Calendario'],   history.push('/cliente/firmas');
  // },
  // {
  //   title: 'Credenciales',
  //   cards: ['Accesos'],
  // },
];

export default function SectionsCardsEmployee() {
  const classes = useStyles();
  const history = useHistory();
  const modeClient = useSelector(getClientMode());
  const cardStyle = modeClient ? classes.cardDark : classes.card;
  const nameStyle = modeClient ? classes.nameCardDark : classes.nameCard;
  const titleStyle = modeClient ? classes.titleDark : classes.title;

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        {cards.map(item => {
          return (
            <>
              {item.cards.map(items => {
                return (
                  <>
                    <div
                      className={cardStyle}
                      onClick={() => {
                        history.push(items.path);
                      }}
                    >
                      <p className={titleStyle}>{item.section}</p>
                      <div
                        style={{
                          width: 'fit-content',
                        }}
                      >
                        <p className={nameStyle}>{items.title}</p>
                      </div>
                    </div>
                    {/* </div> */}
                  </>
                );
              })}
            </>
          );
        })}
      </div>
    </div>
  );
}
